import { isEmpty } from './index'

export const required = value => {
  if (value === null || value === undefined || value === '') {
    return '这是必填项'
  }

  if (Array.isArray(value) && value.length === 0) {
    return '这是必填项'
  }

  return true
}

export const booleanValidator = value => (value === 0 || value === 1 ? true : '这是必选项')

export const trueValidator = value => (value === 1 || value === true ? true : '这是必选项')

export const isNotNullValidator = value => (value === '' || value === null ? '这是必选项' : true)

export const specialCharValidator = item => /[`[\]]/im.test(item)

export const emptyValidator = item => item === '' || typeof item === 'undefined' || item === null

// eslint-disable-next-line consistent-return
export const timeValidator = time => {
  if (time !== null) return time.split(':')[0] >= new Date().getHours() && time.split(':')[1] >= new Date().getMinutes()

  return false
}

export const emailValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  // eslint-disable-next-line
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  if (Array.isArray(value)) {
    return value.every(val => re.test(String(val)))
  }

  return re.test(String(value)) || 'The Email field must be a valid email'
}

export const passwordValidator = password => {
  /* eslint-disable no-useless-escape */
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password)

  return (
    // eslint-disable-next-line operator-linebreak
    validPassword ||
    '密码最少八个字符，至少一个大写字母，一个小写字母和一个数字！'
  )
}

export const mobileValidator = value => {
  /* eslint-disable no-useless-escape */
  const regExp = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/

  return (
    // eslint-disable-next-line operator-linebreak
    regExp.test(value) ||
    '请输入正确的手机号格式！'
  )
}

export const confirmedValidator = (value, target) =>
  // eslint-disable-next-line implicit-arrow-linebreak
  value === target || '确认密码与新密码不一致！'

export const between = (value, min, max) => () => {
  const valueAsNumber = Number(value)

  return (Number(min) <= valueAsNumber && Number(max) >= valueAsNumber) || `Enter number between ${min} and ${max}`
}

export const integerValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  if (Array.isArray(value)) {
    return value.every(val => /^-?[0-9]+$/.test(String(val)))
  }

  return /^-?[0-9]+$/.test(String(value)) || 'This field must be an integer'
}

export const regexValidator = (value, regex) => {
  if (isEmpty(value)) {
    return true
  }

  let regeX = regex
  if (typeof regeX === 'string') {
    regeX = new RegExp(regeX)
  }

  if (Array.isArray(value)) {
    return value.every(val => regexValidator(val, { regeX }))
  }

  return regeX.test(String(value)) || 'The Regex field format is invalid'
}

export const alphaValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  // const valueAsString = String(value)

  return /^[A-Z]*$/i.test(String(value)) || 'The Alpha field may only contain alphabetic characters'
}

export const urlValidator = value => {
  if (value === undefined || value === null || value.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/

  return re.test(value) || 'URL is invalid'
}

export const lengthValidator = (value, length) => {
  if (isEmpty(value)) {
    return true
  }

  return value.length === length || `The Min Character field must be at least ${length} characters`
}
export const alphaDashValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  const valueAsString = String(value)

  return /^[0-9A-Z_-]*$/i.test(valueAsString) || 'All Character is not valid'
}

export const positiveValidator = value => value > 0 || '必填，且必须大于0'

export const positiveIntegerValidator = value => (value?.toString()?.includes('.') ? '必填，且必须为大于0的整数' : value > 0 || '必填，且必须为大于0的整数')
